module.exports = __webpack_public_path__ + "_assets/img/coin-gold.607f5bcc.svg";